module.exports = __webpack_public_path__ + "svg/illustration-agent.a25e6c0.svg";